<template>
  <div class="app-container">
    <el-card class="box-card">
      <folded-panel infoName="项目关键信息">
        <div slot="content">
          <dynamic-form
            ref="form"
            labelWidth="120px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="false"
            @getContent="getContent"
          />
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" @click="submit">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import { addProject, editProject, getProjectInfoById } from "@/api/project";
import { deepClone } from "@/utils/index";
export default {
  name: 'ProjectForm',
  components: {
    FoldedPanel
  },
  data() {
    return {
      initloading: false,
      loading: false,
      form: {},
      formConfig: {
        formItemList: [
        {
            label: "合同主体",
            key: "contract",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            // bindField: "id",
            // listeners: {
            //   confirm: val => {
            //     this.form.customerId = val.id;
            //     this.form.customerName = val.name;
            //     console.log(val, "=======");
            //   }
            // },
            url: "/bizContract",
            tableColumn: [
              {
                property: "businessId",
                label: "合同号"
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              },
              {
                property: 'totals',
                label: '合同总金额'
              }
            ],
            extendParms: { queryFieldItem: "id,code,name,businessId" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "input",
            key: "code",
            label: "项目号",
            value: "",
            span: 8,
            rules: [
              { required: true, message: "项目号不能为空", trigger: "blur" }
            ]
          },
          {
            type: "input",
            key: "name",
            label: "项目名称",
            value: "",
            span: 8,
            rules: [
              { required: true, message: "项目名称不能为空", trigger: "blur" }
            ]
          },
          {
            type: "input",
            key: "contractAmount",
            label: "合同金额",
            span: 8,
            disabled: true
          },
          {
            label: "项目经理",
            key: "projectManage",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
               {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "inputNumber",
            key: "subContractAmount",
            label: "子项目合同金额",
            placeholder: "请输入子项目合同金额",
            span: 8,
            min: 0,
            controls: false,
            precision: 2,
            /* rules: [
              { required: true, message: "合同折扣率不能为空", trigger: "blur" }
            ] */
          },
          {
            label: "业务集团",
            key: "businessGroup",
            type: "select",
            span: 8,
            options: [
              // 钢铁，能碳，idos,其他
              { value: "钢铁", label: "钢铁" },
              { value: "能碳", label: "能碳" },
              { value: "idos", label: "idos" },
              { value: "其他", label: "其他" }
            ],
          },
          {
            label: "签约公司",
            key: "signCompany",
            type: "select",
            span: 8,
            options: [
              // 上海优也、苏州优也
              { value: "上海优也", label: "上海优也" },
              { value: "苏州优也", label: "苏州优也" }
            ],
          },
          {
            span: 8,
            label: '维保时间',
            key: 'maintainDate',
            value: null,
            type: 'date',
            subtype: 'daterange',
            valueFormat: "yyyy-MM-dd",
            'start-placeholder': "开始日期",
            'end-placeholder': "结束日期"
          },
          /* {
            span: 8,
            label: '验收时间',
            key: 'checkDate',
            type: 'date',
            viewFormat: "yyyy-MM-dd",
            placeholder: "请选择"
          }, */
          {
            span: 8,
            key: "checkDate",
            value: null,
            placeholder: "请选择",
            type: "date",
            label: "验收日期",
            valueFormat: "yyyy-MM-dd",
          },
          {
            type: "radio",
            key: "category",
            label: "项目类别",
            value: "D",
            span: 8,
            options: [
              {
                label: '交付项目',
                value: 'D'
              },
              {
                label: '其他',
                value: 'M'
              }
            ],
            rules: [
              { required: true, message: "项目类别不能为空", trigger: "change" }
            ]
          },
          {
            type: "radio",
            key: "isClosed",
            label: "项目状态",
            value: 0,
            span: 8,
            options: [
              {
                label: '开启',
                value: 0
              },
              {
                label: '关闭',
                value: 1
              }
            ],
            rules: [
              { required: true, message: "项目类别不能为空", trigger: "change" }
            ]
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注",
            span: 24
          }
        ]
      }
    };
  },
  created() {
    this.initData();
  },
  methods: {
    getContent(val) {
      if (val.key === 'contract') {
        console.log(val)
        this.form.contractAmount = val.value.totals || 0
        this.form.subContractAmount = val.value.totals || 0
        this.form.projectManage = val.value.personSell || {}
        this.form.code = val.value.businessId
        this.form.name = val.value.name
      }
    },
    async initData() {
      if (this.$route.query.id) {
        const result = await getProjectInfoById(this.$route.query.id);
        const form = result.data;
        if (form.contract) {
          form.contract = { id: form.contractId, name: form.contract.name };
        }
        if (form.personManager) {
          form.projectManage = { id: form.projectManageId, name: form.personManager.name };
        }
        if (form.maintainStartDate && form.maintainEndDate) {
          form.maintainDate = [form.maintainStartDate, form.maintainEndDate]
        }
        this.form = form;
      }
    },
    submit() {
      this.$refs["form"].validate().then(() => {
        const data = deepClone(this.form);
        if (data.contract) {
          data.contractId = data.contract.id;
        }
        if (data.projectManage) {
          data.projectManageId = data.projectManage.id;
        }
        if (data.maintainDate) {
          data.maintainStartDate = data.maintainDate[0]
          data.maintainEndDate = data.maintainDate[1]
        }
        if (this.form.id) {
          this.doEdit(data);
        } else {
          this.doAdd(data)
          }
        this.cancel();
      });
    },
    doAdd(data) {
      this.loading = true;
      addProject(data)
        .then(res => {
          // this.resetForm();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.cancel();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    doEdit(data) {
      this.loading = true;
      editProject(data)
        .then(res => {
          // this.resetForm();
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.cancel();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    cancel() {
      this.$router.push("/basic/project");
      this.form = {}
    }
  }
};
</script>
<style lang="scss" scoped>
.button {
  padding-top: 20px;
  text-align: right;
  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }
  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
</style>
